exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".word-break-all {\n  word-break: break-all;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.well-position {\n  margin-bottom: 0;\n  overflow: hidden;\n  display: block;\n  transition: max-height 0.2s;\n}\n\n.expand-button-position {\n  position: relative;\n  top: -12px;\n}\n\n.buttons-table-cell {\n  min-width: 130px;\n  text-align: right;\n  position: relative;\n}\n\n.target-group-text {\n  display: block;\n  margin-top: 5px;\n  text-align: left;\n}\n\n.dialog-timing {\n  width: 120px;\n  margin-top: 3px;\n  text-align: left;\n}\n\n.dialog-timing__start {\n  display: block;\n}\n\n.dialog-timing__end {\n  display: block;\n}\n\n.langInfo {\n  position: absolute;\n  bottom: 5px;\n  right: 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/dialogs/dialogs-overview/dialogs-overview.component.css
// module id = ../../../../../src/app/modules/dialogs/dialogs-overview/dialogs-overview.component.css
// module chunks = main